<template>
  <title>0LP | Video Editing</title>
  <link rel="stylesheet" href="\css\videoediting.css">
  <body>
    <div class="videoediting-title-container">
      <a href="/" ><img class="logo" src="/images/logo/logo_crp.png" ></a>

      <h3>Video Editing Gallery</h3>
    </div>
    <div class="img-gallery">
      <!-- <img 
      v-for="(image,index) in images" 
    :key="index" 
    :src="image.path" 
    @click="openVideo(image.video_code)" /> -->
    <img 
      
      v-for="video in videos" 
      v-bind:key="video.video_code" 
      :src="'https://img.youtube.com/vi/' + video.video_code + '/0.jpg'" 
      @click="openVideo(video.video_code)" />
    </div>
    
    <div v-if="showVideoOverlay" class="full-img" @click="closeVideo" >
      <!-- <div class="frame"> -->
        <iframe
          :src="'https://www.youtube.com/embed/' + activeVideoCode + '?rel=0&showinfo=0&controls=0&autoplay=1'"
          frameborder="0"
          allowfullscreen
          
        ></iframe>
        <!-- <video controls ref="videoPlayer" v-if="video_path" autoplay muted loop>
          <source :src="video_path" type="video/mp4">
          Your browser does not support the video tag.
        </video> -->
      <!-- </div> -->
    </div>
</body>
</template>

  
  <script>
//  import axios from 'axios';
  export default {
    name:"VideoEditing",
    data() {
      return {
        video_path: '',
      images: [],
      videos: [],
      showVideoOverlay: false,
      activeVideoCode: null,
      };
    },
    created() {
      this.fetchVideoediting();
    },
    mounted(){
      // this.fetchVideoediting();
    },
    methods: {
      async fetchVideoediting() {
        try {
        const response = {
  videos: [
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'HvCsPPpzt0Q'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'DegKZj7u3zU'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'mwMoh2kbYB8'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'Kgrt2uyyIQw'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'wAwMJ6Tzg4Y'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'KCXS3PPAJ_E'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'jxD57-4Ii7E'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'o0FhQwc7ATw'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 't_Vb-CT00p4'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'Tl5yzVgCrTI'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'xqJkrpSFu50'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: '-hmg4Ao-bak'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'SHqttTUYISc'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: '791aE-rZw1Y'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'zOh-FnrmejE'
    },
    {
      id: 1,
      title: null,
      category: 'videoediting',
      path: '',
      type: 'video',
      video_code: 'fYny5lnXNac'
    },
    
  ],
  images: []
};
        this.videos = response.videos;
        this.images = response.images;
        if (this.videos.length > 0) {
          this.video_path = this.videos[1].video_code;
        }
      } catch (error) {
        console.error('Error fetching video editing details:', error);
      }
      },
      openVideo(code) {
        const video = this.videos.find(video => video.video_code == code);
        if (video) {
          
          this.activeVideoCode = video.video_code;
          this.$nextTick(() => {
          const videoPlayer = this.$refs.videoPlayer;
          if (videoPlayer) {
            videoPlayer.load();
          }
        });
        } else {
          console.error('Video not found for code:', code);
        }
        // this.activeVideoCode = code;
        this.showVideoOverlay = true;
      },
      closeVideo() {
        this.showVideoOverlay = false;
        this.activeVideoCode = null;
      },
      // videoUrl(video_code) {
      //   const video = this.videos.find(video => video.id == video_code);
      //   if (video) {
          
      //     this.video_path = video.path;
      //     this.$nextTick(() => {
      //     const videoPlayer = this.$refs.videoPlayer;
      //     if (videoPlayer) {
      //       videoPlayer.load();
      //     }
      //   });
      //   } else {
      //     console.error('Video not found for code:', video_code);
      //   }
      // },
    },
  };
  </script>
  